import React from "react";
import { Outlet } from "react-router-dom";

const QRPageLayout: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default QRPageLayout;
